module.exports = __webpack_public_path__ + "img/8b4caf4f54aadf547fe3da822f48454d.png";